import { getSubcategoriesFor } from "../../../utils/productCategories";

export const isLocalDevEnvironment = () => {
  if (process.env.NODE_ENV === "production") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
};

const buildTerms = (title, brandName, start, expiry) =>
  [
    "TERMS AND CONDITIONS (LOCALHOST TEST)",
    "",
    `Vendor: ${brandName || "Test Vendor"}`,
    `Deal: ${title}`,
    `Valid from ${start} to ${expiry}.`,
    "",
    "Offer Details:",
    "Original Price: GHS 200.00",
    "Discounted Price: GHS 150.00",
    "Savings: GHS 50.00",
    "",
    "Redemption:",
    "- In-store: present DealBoxx code and registered phone number.",
    "- Online: redeem at https://google.com",
    "",
    "Limitations:",
    "- One redemption per customer unless stated otherwise.",
    "- Cannot be combined with other promotions.",
    "- While stocks last.",
  ].join("\n");

export const buildDevAutofillState = ({
  vendorId,
  brandName,
  existingFormData,
}) => {
  const today = new Date();
  const start = today.toISOString().slice(0, 10);
  const expiryDate = new Date(today);
  expiryDate.setDate(expiryDate.getDate() + 21);
  const expiry = expiryDate.toISOString().slice(0, 10);
  const stamp = Date.now().toString().slice(-4);

  const productCategory = "Electricals";
  const subcategories = getSubcategoriesFor(productCategory);
  const productSubcategory = subcategories[0] || "Other";
  const title = `Sample Deal ${stamp}`;

  return {
    formData: {
      ...existingFormData,
      title,
      product_name: `Test Product ${stamp}`,
      productCategory,
      product_subcategory: productSubcategory,
      category: [productCategory],
      gender: ["All Genders"],
      description: "Localhost autofill description for quick deal testing.",
      offer_type: "discount",
      discount_original_price: "200",
      discount_sale_price: "150",
      price: "200",
      discounted_price: "150",
      original_sum: "",
      bundle_price: "",
      bundle_savings: "",
      bogo_item_price: "",
      bogo_quantity: 1,
      bogo_free_quantity: 1,
      bundle_skus: [],
      validity_type: "regular",
      start_date: start,
      expiry_date: expiry,
      flash_start_time: "",
      flash_end_time: "",
      flash_start_date: "",
      flash_duration: null,
      phone_number: "249158582",
      sms_content: "This is a localhost test deal from DealBoxx. Your redemption code is ready.",
      sku: `DEV-${stamp}-SKU`,
      properties: [{ name: "Condition", value: "New" }],
      redemption_type: ["Online", "In-store"],
      online_link: "https://google.com",
      redemption_instructions: "Present your DealBoxx redemption code in store or enter it online at checkout.",
      refund_policy: "Refunds follow the vendor standard policy for test deals.",
      region_location: [{ region: "all", location: "all" }],
      redemption_region_location: [{ region: "all", location: "all" }],
      partner_location: [],
      redemption_partner_location: [],
      target_branches: [],
      redemption_limits: [],
      exclusions: [],
      delivery_fee: "not_apply",
      free_delivery_areas: [],
      no_age_limit: true,
      min_age: "",
      max_age: "",
      quantity: 0,
      promote_deal: 0,
      vendor_id: vendorId ?? existingFormData.vendor_id,
      terms_and_conditions: buildTerms(title, brandName, start, expiry),
      image: existingFormData.image ?? null,
      images: existingFormData.images ?? [],
    },
    companionState: {
      startDate: start,
      endDate: expiry,
      daysToExpiry: 21,
      redemptionLocationType: "region",
      redemptionLocationTypeStep4: "region",
      selectAllLocations: true,
      selectAllRedemptionLocations: true,
      selectedBranches: [],
      selectedRedemptionBranches: [],
      selectedPartners: [],
      selectedRedemptionPartners: [],
      currentStep: 2,
      stepValidation: { 1: true, 2: true, 3: true, 4: true, 5: true },
      termsInputType: "custom",
      isPriceValid: true,
      templateFields: {
        vendor: brandName || "Test Vendor",
        validityStart: start,
        validityEnd: expiry,
        location: "Nationwide",
        privacyLink: "https://dealboxx.promo/privacy",
        doaPeriod: "7",
        redemptionProcess: "Show your DealBoxx code in store or online.",
      },
    },
  };
};
